// extracted by mini-css-extract-plugin
export default {"top":"PayerSearch_top_B59Ch"};